import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Field, reduxForm } from 'redux-form';
import { Avatar, Chip } from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import withTranslation from '../../hoc/withTranslation';
import styles from '../../styles/styles';
import {
    renderNumberField,
    renderSelectField,
    renderSuperSelectField,
    renderTextField,
} from '../../services/form';
import style from '../../styles/styles';

const validate = values => {
    const errors = {};
    const requiredFields = [
        'name',
        'daily_distance_min',
        'daily_distance_max',
        'point_distance_max',
        'hosting_distance_max',
        'trail_id',
    ];
    requiredFields.forEach(field => {
        if (values[field]
            === undefined
            || values[field]
            === null
            || values[field].toString()
            === '') {
            errors[field] = i18n.t('generic.required');
        }
    });
    if (
        errors['daily_distance_min'] === undefined
        && parseInt(values['daily_distance_min'], 10) <= 0
    ) {
        errors['daily_distance_min'] = i18n.t('module.road_book.daily_distance_min_lt_zero');
    }
    if (
        errors['daily_distance_max'] === undefined
        && parseInt(values['daily_distance_max'], 10) <= 0
    ) {
        errors['daily_distance_max'] = i18n.t('module.road_book.daily_distance_max_lt_zero');
    }
    if (
        errors['point_distance_max'] === undefined
        && parseInt(values['point_distance_max'], 10) <= 0
    ) {
        errors['point_distance_max'] = i18n.t('module.road_book.point_distance_max_lt_zero');
    }
    if (
        errors['hosting_distance_max'] === undefined
        && parseInt(values['hosting_distance_max'], 10) <= 0
    ) {
        errors['hosting_distance_max'] = i18n.t('module.road_book.hosting_distance_max_lt_zero');
    }
    if (
        errors['daily_distance_max'] === undefined
        && parseInt(values['daily_distance_min'], 10) > parseInt(values['daily_distance_max'], 10)
    ) {
        errors['daily_distance_max'] = i18n.t('module.road_book.daily_distance_max_lt_min');
    }
    return errors;
};

const parseIntOrReturnZero = (val) => {
    if (val !== undefined && val !== null) {
        if (typeof val === 'string' && val === '') {
            return 0;
        }
        return parseInt(val, 10);
    }
    return 0;
};

export class RoadBookConfigurationForm extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
        roadBookConfiguration: PropTypes.object,
        onFormReset: PropTypes.func,
        types: PropTypes.array,
        trails: PropTypes.array,
        customFields: PropTypes.array,
    };

    static defaultProps = {
        roadBookConfiguration: null,
        trails: [],
        customFields: [],
        types: [],
    };
    onResetForm = () => {
        this.props.reset();

        if (this.props.onFormReset) {
            this.props.onFormReset();
        }
    };

    renderTypesSelection = (types, hintText) => {
        if (!types || types.length === 0) {
            return hintText;
        }

        return (
            <div style={style.chip.wrapper}>
                {types.map(({
                    value,
                    label,
                }, index) => {

                    let type = this.props.types.find((type) => {
                        return type.id === value;
                    });

                    if (type) {
                        return (
                            <Chip key={value} style={style.chip.margin}>
                                <Avatar
                                    icon={type.picture
                                        && <img
                                            src={type.picture}
                                            alt=""
                                            style={style.image.contain}
                                        />}
                                    size={20}
                                    backgroundColor={type.color}
                                    style={{ overflow: 'hidden' }}
                                />
                                {type.name}
                            </Chip>
                        );
                    } else {
                        return hintText;
                    }
                })}
            </div>
        );
    };

    render() {
        const {
            handleSubmit,
            pristine,
            submitting,
            t,
        } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div>

                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={t('generic.name')}
                        fullWidth={true}
                    />
                    <Field
                        type="number"
                        id="daily_distance_min"
                        name="daily_distance_min"
                        component={renderNumberField}
                        label={t('module.road_book.daily_distance_min')}
                        fullWidth={true}
                        inputMode="numeric"
                        parse={(val) => parseIntOrReturnZero(val)}
                    />
                    <Field
                        type="number"
                        id="daily_distance_max"
                        name="daily_distance_max"
                        component={renderNumberField}
                        label={t('module.road_book.daily_distance_max')}
                        fullWidth={true}
                        inputMode="numeric"
                        parse={(val) => parseIntOrReturnZero(val)}
                    />
                    <Field
                        type="number"
                        id="point_distance_max"
                        name="point_distance_max"
                        component={renderNumberField}
                        label={t('module.road_book.point_distance_max')}
                        fullWidth={true}
                        inputMode="numeric"
                        parse={(val) => parseIntOrReturnZero(val)}
                    />
                    <Field
                        type="number"
                        id="hosting_distance_max"
                        name="hosting_distance_max"
                        component={renderNumberField}
                        label={t('module.road_book.hosting_distance_max')}
                        fullWidth={true}
                        inputMode="numeric"
                        parse={(val) => parseIntOrReturnZero(val)}
                    />
                    <Field
                        id="trail_id"
                        name="trail_id"
                        component={renderSelectField}
                        fullWidth={true}
                        label={t('module.open_explore.trail')}
                    >
                        {this.props.trails
                            ? this.props.trails
                                .filter((t) => t.gpx !== null)
                                .map(trail => (
                                    <MenuItem
                                        key={trail.id}
                                        value={trail.id}
                                        primaryText={trail.name}
                                    />
                                ))
                            : null}
                    </Field>
                    <Field
                        id="sort_custom_field_id"
                        name="sort_custom_field_id"
                        component={renderSelectField}
                        fullWidth={true}
                        label={t('module.road_book.sort_custom_field')}
                    >
                        {this.props.customFields && this.props.customFields.map(customField => (
                            <MenuItem
                                key={customField.id}
                                value={customField.id}
                                primaryText={customField.name}
                            />
                        ))}
                    </Field>
                    <Field
                        id="point_types_id"
                        name="point_types_id"
                        label={t('module.road_book.point_types')}
                        style={{ marginTop: 30 }}
                        component={renderSuperSelectField}
                        fullWidth={true}
                        selectionsRenderer={this.renderTypesSelection}
                        normalize={values => {
                            if (!values) {
                                return [];
                            }

                            return values.map(({
                                value,
                                label,
                            }) => {
                                return value;
                            });
                        }}
                        format={values => {
                            if (!values) {
                                return [];
                            }

                            return values.map(typeId => {
                                const type = this.props.types.find(type => type.id === typeId);
                                return {
                                    value: typeId,
                                    label: type
                                        ? type.name
                                        : typeId,
                                };
                            });
                        }}
                    >
                        {this.props.types && this.props.types.map((type) => (
                            <div key={type.id} value={type.id} label={type.name}>
                                <Avatar
                                    style={style.margin.right.small}
                                    icon={type.picture && <img
                                        src={type.picture}
                                        alt=""
                                        style={style.image.contain}
                                    />}
                                    size={20}
                                    backgroundColor={type.color}
                                />
                                {type.name}
                            </div>
                        ))}
                    </Field>
                    <Field
                        id="hosting_types_id"
                        name="hosting_types_id"
                        label={t('module.road_book.hosting_types')}
                        style={{ marginTop: 30 }}
                        component={renderSuperSelectField}
                        fullWidth={true}
                        selectionsRenderer={this.renderTypesSelection}
                        normalize={values => {
                            if (!values) {
                                return [];
                            }

                            return values.map(({
                                value,
                                label,
                            }) => {
                                return value;
                            });
                        }}
                        format={values => {
                            if (!values) {
                                return [];
                            }

                            return values.map(typeId => {
                                const type = this.props.types.find(type => type.id === typeId);
                                return {
                                    value: typeId,
                                    label: type
                                        ? type.name
                                        : typeId,
                                };
                            });
                        }}
                    >
                        {this.props.types && this.props.types.map((type) => (
                            <div key={type.id} value={type.id} label={type.name}>
                                <Avatar
                                    style={style.margin.right.small}
                                    icon={type.picture && <img
                                        src={type.picture}
                                        alt=""
                                        style={style.image.contain}
                                    />}
                                    size={20}
                                    backgroundColor={type.color}
                                />
                                {type.name}
                            </div>
                        ))}
                    </Field>
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={t('generic.save')}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    <RaisedButton
                        style={styles.formButton}
                        label={t('generic.reset')}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={this.onResetForm}
                    />
                </div>
            </form>
        );
    }

}

export default reduxForm({
    form: 'editRoadBookConfiguration',
    validate,
})(withTranslation(RoadBookConfigurationForm));



// WEBPACK FOOTER //
// src/components/roadbook/RoadBookConfigurationForm.js